/**
 *
 */
export function GameRules(props: { totalTurns: number }) {
  return (
    <div className="koth-tutorial-rules">
      Stronzemon Chess è un gioco simile agli scacchi, ma ovviamente non lo è manco per il cazzo.
      <br /><br />
      Ci sono due modi pe vincere:
      <br />
      <ol>
        <li>
          Catturare il re avversario come negli scacchi.
        </li>
        <li>
          Portare il proprio re nella casella centrale. Vince se non può essere catturato o teletrasportato nel turno successivo.
        </li>
      </ol>
      Ogni partita è composta da {props.totalTurns} turni, e come negli scacchi ogni pezzo fà come je pare. Seleziona i personaggi in alto per conoscerli!
    </div>
  );
}
